import React, {useEffect, useRef, useState} from 'react';

import classNames from "classnames";
import styles from "./shadow-wrapper.module.scss";
import {useScrollBoundariesDetector} from "../../../infrastructure/hooks/useScrollBoundaryDetector";

export const ShadowWrapper = (({children, className, isRtl, shadowWidth = 16, shouldRenderShadows = true, disableThemeSupport = false}) => {
  const scrollRef = children.props.ref || useRef(null);

  const [isVisible, setIsVisible] = useState(true)
  const [isScrollable, setIsScrollable] = useState(false)

  useEffect(() => {
    if(scrollRef.current && shouldRenderShadows) {
      const parentWidth: Number = scrollRef.current?.parentElement?.parentElement?.clientWidth;

      setIsVisible(parentWidth < scrollRef.current?.scrollWidth)
      setIsScrollable(parentWidth < scrollRef.current?.scrollWidth)
    }
  }, [scrollRef.current]);

  const childrenContent = scrollRef ? children : React.cloneElement(children, {ref: scrollRef});
  const {isReachedToStart, isReachedToEnd} = useScrollBoundariesDetector(scrollRef, isRtl)

  if(!isVisible) {
    return children
  }

  const startShadowProps = {
    className: classNames(styles.start_shadow, {[styles.default_shadow]: disableThemeSupport}),
    style: {width: isScrollable && isReachedToStart ? shadowWidth : 0}
  }

  const endShadowProps = {
    className: classNames(styles.end_shadow, {[styles.default_shadow]: disableThemeSupport}),
    style: {width: isScrollable && isReachedToEnd ? shadowWidth : 0}
  }

  return (
    <div className={classNames(styles.shadow_container, className)}>
      <div {...startShadowProps}/>
      {childrenContent}
      <div {...endShadowProps}/>
    </div>
  )
});

